module.exports = __webpack_public_path__ + "img/tonno-cipolle.1292c42c.png";